import service from "@/utils/request"
export function getBrandListApi(data){
    return service({
        url: '/brand/getBrandList',
        method: 'get',
        params:data
    })
}
